
import Result from './Result/Result';

import "./Results.css";
import SearchIcon from '@mui/icons-material/Search';
import Divider from '@mui/material/Divider';

import { useMediaQuery,Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
export default function Results(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  let results = props.documents.map((result, index) => {
    return  <div key={index} className='col-md-12'>
    <Result document={result.document} query={props.query} source={props.source}/>
    {/* Add Divider except for the last item */}
    {index < props.documents.length - 1 && <Divider sx={{ borderBottom: '1px solid #14143C', margin: '10px 0' }}/>}
  </div>
  });

  let beginDocNumber = Math.min(props.skip + 1, props.count);
  let endDocNumber = Math.min(props.skip + props.top, props.count);

  return (
<div>
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
    <p className="results-info" style={{ flex: isMobile?'0 0 63%':'0 0 70%', margin: 0 }}>
      <SearchIcon style={{ marginRight: 4 }} />
      Showing {beginDocNumber}-{endDocNumber} of {props.count.toLocaleString()} results {(props.query === "*" || props.query.trim() === "") ? "" : <>for <b><span style={{marginLeft:isMobile?'30px':'0px'}}>{props.query}</span></b></>}
    </p>

    <div style={{ display: 'flex', gap: '8px' }}>
      <Button
        onClick={() => props.setSortDate(false)}
        style={{
          backgroundColor: !props.sortDate ? props.color : '#f0f0f0',
          color: !props.sortDate ? 'white' : 'black',
          border: 'none',

          borderRadius: '4px',
          padding: isMobile ? '8px 12px':'8px 16px',
          cursor: 'pointer',
          fontSize:isMobile ? '12px': '14px',
          textTransform:'capitalize'
        }}
      >
        Relevance
      </Button>

      <Button
        variant="contained"
        onClick={() => props.setSortDate(true)}
        style={{
          backgroundColor: props.sortDate ? props.color  : '#f0f0f0',
          color: props.sortDate ? 'white' : 'black',
          border: 'none',
          padding: isMobile ? '8px 12px':'8px 16px',
          cursor: 'pointer',
          fontSize: isMobile ? '12px': '14px',
          borderRadius: '4px',
            textTransform:'capitalize'
        }}
      >
        Date
      </Button>

    </div>
  </div>

  <div className="row-cols-md-5 results">
    {results}
  </div>
</div>


  );
};
